module.exports = __webpack_public_path__ + "static/img/en-newsba.ce6944e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/news/en-newsba.jpg
// module id = OgUJ
// module chunks = 0